import React, { useEffect } from 'react';

import OrderProcessingProgressBar from 'organisms/orderProcessingProgressBar/container/orderProcessingProgressBar';
import { isValidObject, redirectToOrderProcessingPage } from 'common/utilities/utils';
import { updateOrderTrackingDetailsInLocalStorage } from 'common/utilities/orderProcessingSummaryUtils';

const TrackOrderView = props => {
  const { trackerDetails } = props;
  const detailsProps = {
    orderDetails: trackerDetails,
  };
  useEffect(() => {
    console.log(trackerDetails);
    if (isValidObject(trackerDetails?.postOrderDetails)) {
      updateOrderTrackingDetailsInLocalStorage({
        trackerDetails,
        orderDetails: trackerDetails?.postOrderDetails,
        redirectTo: redirectToOrderProcessingPage,
        props: trackerDetails?.props,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackerDetails?.postOrderDetails]);

  return (
    <React.Fragment>
      <div className={`trackOrderPage col-12 ${trackerDetails?.isMobileView ? 'mobileView' : ''}`}>
        <OrderProcessingProgressBar {...detailsProps} />
      </div>
    </React.Fragment>
  );
};

export default React.memo(TrackOrderView);
